export default __webpack_public_path__ + "static/media/img.88dd43ac.png";